import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacebookModule } from 'ngx-facebook';
import { SocialShareComponent } from './components/social-share/social-share.component';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
@NgModule({
  imports: [
    CommonModule,
    FbShareModule,
    WhatsappShareModule,
    FacebookModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ],
  declarations: [SocialShareComponent],
  exports: [SocialShareComponent]
})
export class SocialShareModule { }
